import { Link } from "react-router-dom";
import { OdingardLogo } from "../brand/OdingardLogo";
import {
  ALL_PRODUCTS,
  CERBERUS_SITE,
  INDUSTRIES,
  SOLUTIONS,
  TRACELOCK_APP,
  WARDEN_SERVICES,
} from "../nav/navigation";

const YEAR = new Date().getFullYear();

export function SiteFooter() {
  return (
    <footer className="ftr">
      <div className="ftr__cols">
        <div className="ftr__col">
          <h4>Products</h4>
          <ul>
            {ALL_PRODUCTS.map((p) => (
              <li key={p.slug}>
                <Link to={p.href}>{p.name}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="ftr__col">
          <h4>Solutions</h4>
          <ul>
            {SOLUTIONS.map((s) => (
              <li key={s.href}>
                <Link to={s.href}>{s.name}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="ftr__col">
          <h4>Warden Services</h4>
          <ul>
            {WARDEN_SERVICES.map((g) => (
              <li key={g.title}>
                <Link to="/warden">{g.title}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="ftr__col">
          <h4>Industries</h4>
          <ul>
            {INDUSTRIES.map((i) => (
              <li key={i.href}>
                <Link to={i.href}>{i.name}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="ftr__col">
          <h4>Company</h4>
          <ul>
            <li>
              <Link to="/company">About Us</Link>
            </li>
            <li>
              <Link to="/company#why">Why Odingard?</Link>
            </li>
            <li>
              <Link to="/company#leadership">Leadership</Link>
            </li>
            <li>
              <Link to="/contact?topic=press">Press</Link>
            </li>
            <li>
              <Link to="/contact?topic=investors">Investor Inquiries</Link>
            </li>
            <li>
              <Link to="/contact">Contact Us</Link>
            </li>
          </ul>
        </div>

        <div className="ftr__col">
          <h4>Get started</h4>
          <ul>
            <li>
              <Link to="/demos">Demos and Trials</Link>
            </li>
            <li>
              <Link to="/contact?topic=briefing">Request a briefing</Link>
            </li>
            <li>
              <a href={CERBERUS_SITE.pricing}>Cerberus pricing</a>
            </li>
            <li>
              <a href={TRACELOCK_APP.signUp}>Start a TraceLock workspace</a>
            </li>
            <li>
              <a href="https://trust.odingard.com">Trust Center</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="ftr__base">
        <Link to="/" className="ftr__logo" aria-label="Odingard home">
          <OdingardLogo height={24} />
        </Link>
        <p className="ftr__legal">
          © {YEAR} Odingard. A Six Sense Enterprise Services company.
        </p>
        <nav className="ftr__legal-links" aria-label="Legal">
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
          <Link to="/security-disclosure">Responsible Disclosure</Link>
          <Link to="/sitemap">Sitemap</Link>
        </nav>
      </div>
    </footer>
  );
}
